<script>
    import Layout from "../../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Monitor from "@/services/Monitor";

    export default {
        components: { Layout, PageHeader },
        page: {
            title: "API Errors",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                title: "Errors Log",
                items: [
                    {
                        text: "Logs",
                    },
                    {
                        text: "Errors Log",
                        active: true,
                    },
                ],
                isBusy: false,
                queuesData: {},
                showLoader:false,
                error: '',
                tableData: [],
                totalRows: 0,
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "timestamp",
                sortDesc: true,
                content: '',
                fields: [
                    {
                        key: "id",
                        label: "ID",
                        sortable: true
                    },
                    {
                        key: "method",
                        label: "Method",
                        sortable: false
                    },
                    {
                        key: "servce",
                        label: "Service",
                        sortable: true
                    },
                    {
                        key: "route",
                        label: "Route",
                        sortable: true
                    },
                    {
                        key: "error_code",
                        label: "Error Code",
                        sortable: true
                    },
                    {
                        key: "error_message",
                        label: "Error Message",
                        sortable: false
                    },
                    {
                        key: "timestamp",
                        label: "Timestamp",
                        sortable: true
                    },
                    "action",
                ]
            };
        },
        destroyed() {
            clearInterval(this.timer);
        },
        middleware: "authentication",
        async mounted() {
            try {
                await this.getApiErrors();
                this.setupInterval();
            } catch (error) {
                console.error('Error during component initialization:', error);
            }
        },
        methods: {
            async getApiErrors() {
                try {
                    this.filterData = true;
                    this.toggleBusy();
                    const response = await Monitor.getApiErrors()
                    this.tableData = response.data.data
                    this.totalRows = this.tableData.length
                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                } finally {
                    this.toggleBusy();
                }
            },

            setupInterval() {
                this.timer = setInterval(async () => {
                    try {
                        await this.getApiErrors();
                    } catch (error) {
                        console.error('Error in interval:', error);
                    }
                },120000);
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length;
                this.currentPage = 1;
            }
        }
    };
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">

                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                        id="tickets-table_filter"
                                        class="dataTables_filter text-md-end"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    :busy="isBusy"
                                    :items="tableData"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn"
                                    show-empty
                                    empty-text="No Data Found"
                                    @filtered="onFiltered"
                            >

                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>

                                <template v-slot:cell(route)="tableData">
                                     <span v-if="tableData.item.route && tableData.item.route.length > 40" class="text-nowrap">
                                        {{ tableData.item.route.slice(0, 40) + '... ' }}
                                        <a v-b-popover.hover.html.bottom="tableData.item.route" class="elementPointed float-end" title="Route" size="sm"><i class="uil uil-eye font-size-18"></i></a>
                                      </span>
                                      <span v-else>{{ tableData.item.route }}</span>
                                </template>


                                <template v-slot:cell(error_message)="tableData">
                                     <span v-if="tableData.item.error_message && tableData.item.error_message.length > 40" class="text-nowrap">
                                        {{ tableData.item.error_message.slice(0, 40) + '... ' }}
                                        <a v-b-popover.hover.html.bottom="tableData.item.error_message" class="elementPointed float-end" title="Error Message" size="sm"><i class="uil uil-eye font-size-18"></i></a>
                                      </span>
                                    <span v-else>{{ tableData.item.error_message }}</span>
                                </template>

                                <template v-slot:cell(action)="tableData">
                                    <ul class="list-inline mb-0">
                                        <li class="list-inline-item">
                                            <a href="javascript:void(0);" class="px-2 text-primary" title="Copy Content" @click="copyToClipboard(tableData.item)">
                                                <i class="uil uil-copy font-size-18"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="totalRows"
                                                :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>
